import {useEffect, useState} from 'react';

const wideScreenThreshold = 1247;
const useIsWideScreen = () => {
    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > wideScreenThreshold);

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth < wideScreenThreshold);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isWideScreen;
};

export default useIsWideScreen;